export type NewsItem = {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
  cover: string;
  paragraphs: string[];
};

export const newsList: NewsItem[] = [
  {
    id: "winter-lineup-2026",
    title: "2026 冬季片单前瞻：五部值得留意的日韩情感新作",
    date: "2026-10-12",
    category: "片单推荐",
    summary:
      "从海边小镇的青春故事到首尔顶楼的深夜对话，本季新作普遍收起了感官刺激，转向更克制的情感描写。我们整理了五部在试映后口碑最好的作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20a%20winter%20film%20season%20lineup%2C%20moody%20theater%20seats%20with%20warm%20amber%20projection%20light%2C%20deep%20crimson%20curtains%2C%20elegant%20magazine%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-01&orientation=landscape",
    paragraphs: [
      "这一季的日韩情感电影有一个明显的共同点：它们都在减少台词。导演们更愿意把镜头交给光线、天气和两个人之间的距离，而不是把情绪直接说出来。",
      "在已曝光的片单中，日本方面以《玻璃与雾》《夏日潮汐》为代表，延续了近年文艺片对「未完成关系」的偏爱；韩国方面则以《顶楼花园》《午夜便利店》为主，把注意力放回城市普通人的日常。",
      "值得注意的是，多部作品都选择了短片形式。四十分钟左右的篇幅，让创作者可以把注意力集中在一场对话、一个下午，甚至一次沉默上。",
      "以上片单信息均来自公开的影展与发行资料整理，站内仅提供剧情与创作背景介绍，不涉及任何播放资源。",
    ],
  },
  {
    id: "japan-art-house-trend",
    title: "从《雨夜之诗》说起：日本文艺情色片的留白美学",
    date: "2026-09-28",
    category: "深度观察",
    summary:
      "为什么日本这类作品总是不肯把话说尽？本文从镜头语言、光线与声音设计三个角度，拆解「留白」如何成为表达欲望最有效的方式。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20cinematic%20image%20of%20rain%20on%20a%20window%20with%20blurred%20warm%20interior%20lights%2C%20crimson%20and%20amber%20reflections%2C%20quiet%20melancholic%20mood%2C%20magazine%20feature%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-02&orientation=landscape",
    paragraphs: [
      "在《雨夜之诗》里，男女主角全片没有一句明确的告白。导演白石凉介把整部电影的重心放在雨声上，人物的情绪通过呼吸、沉默和视线的偏移来完成。",
      "这种处理方式并不是回避，而是一种更精确的表达。当语言退场，观众被迫去读那些更细微的信号：谁先移开目光，谁的手停在门把上多了一秒。",
      "光线同样承担叙事功能。片中几乎所有室内戏都只有一盏灯，人物的脸经常一半在光里、一半在暗处。这种不完整，恰好对应了关系的不确定。",
      "对于习惯了直白叙事的观众，这样的作品需要一点耐心。但它留下的余味，往往比任何台词都更长。",
    ],
  },
  {
    id: "korea-urban-romance",
    title: "首尔夜戏地图：那些被反复拍摄的都市情感场景",
    date: "2026-09-15",
    category: "幕后故事",
    summary:
      "汉江边的工作室、江南的深夜酒吧、末班地铁的车厢——这些场景为什么总能承载都市人的情感？我们跟着美术指导走了一遍。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20view%20of%20Seoul%20streets%20with%20warm%20shop%20signs%20and%20rain%20reflections%2C%20crimson%20and%20amber%20city%20glow%2C%20atmospheric%20urban%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-03&orientation=landscape",
    paragraphs: [
      "首尔的城市空间有一种天然的戏剧性：它足够密集，又足够孤独。地铁、便利店、24 小时营业的咖啡馆，都是陌生人可以合理地长时间共处的场所。",
      "《首尔午夜列车》的美术指导在采访中提到，他们刻意选择了一节最旧的车型，因为新的车厢太亮、太干净，反而没有故事感。",
      "灯光是另一个关键。片中所有夜戏都避免使用冷白光，取而代之的是偏橙的路灯与偏红的霓虹，让人物看起来始终处在某种温暖的包围里。",
      "这或许就是都市情感片最核心的魔法：它让观众相信，在这样一座巨大的城市里，两个人的相遇仍然是有可能的。",
    ],
  },
  {
    id: "short-film-rise",
    title: "短片的黄金时代：40 分钟能讲完一段关系吗？",
    date: "2026-08-30",
    category: "行业动态",
    summary:
      "近三年，日韩地区四十分钟左右的情感短片产量增长了近一倍。篇幅变短，表达的密度却在提高。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20image%20of%20a%20film%20clapperboard%20and%20warm%20projector%20light%20in%20a%20dark%20studio%2C%20crimson%20and%20amber%20tones%2C%20minimal%20editorial%20composition%2C%20no%20text&width=800&height=450&seq=news-cover-04&orientation=landscape",
    paragraphs: [
      "短片并不是长片的缩减版。它有自己的结构：通常只有一个转折点，一次情绪的高潮，然后迅速收尾。",
      "《白昼之焰》用四十二分钟讲完了一个下午到黄昏的全部变化，导演闵书妍说，她删掉了整整二十分钟的铺垫，「因为观众不需要被教会怎么心动」。",
      "平台化发行也推动了这股潮流。更短的时长意味着更高的完播率，也意味着创作者可以用更低的成本尝试更冒险的题材。",
      "对观众来说，这是一个好消息：你可以在一个晚上看完三部完全不同风格的作品。",
    ],
  },
  {
    id: "classic-restoration",
    title: "经典修复计划：五部 2000 年代作品重新与观众见面",
    date: "2026-08-11",
    category: "修复重映",
    summary:
      "《樱花旅馆》《纸鹤之约》等五部作品完成 4K 修复，原有的胶片颗粒与色调被完整保留。",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20image%20of%20vintage%20film%20reels%20and%20warm%20projector%20beam%2C%20sepia%20and%20crimson%20tones%2C%20dusty%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-05&orientation=landscape",
    paragraphs: [
      "本次修复由三家亚洲电影资料馆联合完成，全部采用原始底片扫描，没有进行任何数字降噪处理。",
      "修复团队表示，他们刻意保留了胶片本身的颗粒感和轻微的色彩偏移，因为这些「瑕疵」正是那个年代影像气质的一部分。",
      "《樱花旅馆》的导演大庭修三在重映活动上说，二十年后重新看自己的作品，最意外的不是技术，而是演员脸上那种现在很难再拍到的松弛。",
      "五部作品将在部分城市的艺术影院进行限定放映，具体场次以各影院公告为准。",
    ],
  },
  {
    id: "director-interview",
    title: "专访新井透：我拍的从来不是欲望，是犹豫",
    date: "2026-07-22",
    category: "人物专访",
    summary:
      "《玻璃与雾》导演谈创作方法：为什么让演员在开拍前同住两周，为什么删掉了所有配乐。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20style%20image%20of%20a%20film%20director&width=800&height=450&seq=news-cover-06&orientation=landscape's empty chair on a dark soundstage%2C single warm spotlight%2C crimson backdrop%2C cinematic minimal composition%2C no text",
    paragraphs: [
      "新井透的工作室在一栋老楼的四层，墙上贴满了手写的分镜。他说自己从不写完整的剧本，只写「这一场戏里，谁先动」。",
      "《玻璃与雾》的两位主演在开机前被安排在同一间公寓里住了两周，不做任何排练，只是一起做饭、打扫、看片子。",
      "「我要的不是他们演得像一对，而是他们真的习惯了彼此的存在。」新井透说，「习惯比激情难演得多。」",
      "全片没有配乐，只有环境声。他认为音乐太容易替观众下结论，「而我想让他们自己决定，这到底是不是爱情」。",
    ],
  },
  {
    id: "viewing-guide",
    title: "观影指南：如何挑选适合自己的日韩情感电影",
    date: "2026-06-30",
    category: "观影指南",
    summary:
      "从题材标签、片长到叙事节奏，这份指南帮你在三分钟内找到今晚想看的那一部。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20cinematic%20living%20room%20with%20a%20projector%20screen%20glow%2C%20warm%20amber%20lamps%20and%20crimson%20cushions%2C%20magazine%20lifestyle%20photography%2C%20no%20text&width=800&height=450&seq=news-cover-07&orientation=landscape",
    paragraphs: [
      "先确定你今天的状态。如果只想放松，选都市浪漫或青春题材；如果想被某种情绪包裹久一点，文艺与心理类会更合适。",
      "其次是片长。四十分钟左右的短片适合深夜，长片更适合一个完整的周末下午——它们通常需要一点时间才能进入。",
      "最后看导演。同一导演的作品往往共享相似的节奏与镜头习惯，找到喜欢的那一位，比按标签筛选更有效。",
      "本站的分类页支持按地区、年份、片长与题材进行组合筛选，你可以把它当作一个快速的选片工具。",
    ],
  },
  {
    id: "faq-update",
    title: "平台说明更新：关于内容范围与版权声明",
    date: "2026-06-05",
    category: "站务公告",
    summary:
      "本站为影视资讯与作品信息展示平台，不提供任何在线播放与资源下载，全部演示内容均为虚构。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20image%20of%20a%20dark%20desk%20with%20a%20notebook%20and%20warm%20lamp%20light%2C%20crimson%20accent%2C%20clean%20professional%20composition%2C%20no%20text&width=800&height=450&seq=news-cover-08&orientation=landscape",
    paragraphs: [
      "近期我们收到了关于本站内容范围的询问，在此统一说明。",
      "本站仅提供影片的剧情简介、创作背景、演职员信息与相关影视资讯，不提供在线播放、下载链接或任何形式的资源分发。",
      "站内展示的影片名称、导演、演员与剧情均为演示用虚构内容，如与现实作品雷同，纯属巧合。",
      "本站仅面向成年用户。如你未满十八岁，请立即离开。",
    ],
  },
];